import { useState } from "react";
import { School } from "../../interfaces/school";
import { useNavigate } from "react-router-dom";
import { getStates } from "../../services/helpers";
import { createSchool } from "../../services/schoolService";
import ToolTip from "../../components/component-tools/ToolTip";

const CreateSchool = () => {
  const navigate = useNavigate();
  const states = getStates();
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [school, setSchool] = useState<School>({
    schoolID: 0,
    name: "",
    contact: "",
    greeting: "",
    title: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    verified: false,
    comments: "",
    email: "",
    phone: "",
  });

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    field: keyof School
  ) => {
    let value: string | boolean =
      e.target.type === "checkbox"
        ? (e.target as HTMLInputElement).checked
        : e.target.value;
    setSchool({
      ...school,
      [field]: value,
    });
  };

  const handleCreateSchool = async () => {
    if (!school.name || !school.title) {
      setErrorMessage("Name and Title are required fields.");
      return;
    }

    setLoadingSpinner(true);
    try {
      await createSchool(school);
      setSuccessMessage("School created successfully.");
      setTimeout(() => navigate("/admin/master-lists/schools"), 1000);
    } catch (error) {
      console.error("Error creating school:", error);
      setErrorMessage("Failed to create school. Please try again.");
    } finally {
      setLoadingSpinner(false);
    }
  };

  return (
    <div className="content-container">
      <div className="header-container">
        <div className="page-items-container" style={{ alignItems: "center" }}>
          <h1>Create New School</h1>
        </div>
      </div>

      <div className="divider"></div>
      <div className="data-container">
        <div className="field-stacked" style={{ flex: "0 0 50%" }}>
          <label className="field-label">Name:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={school.name}
              onChange={(e) => handleInputChange(e, "name")}
            />
          </div>
        </div>
        <div className="field-stacked" style={{ flex: "0 0 50%" }}>
          <label className="field-label">Contact:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={school?.contact || ""}
              onChange={(e) => handleInputChange(e, "contact")}
            />
          </div>
        </div>
        <div className="field-stacked" style={{ flex: "0 0 50%" }}>
          <label className="field-label">Greeting:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={school.greeting}
              onChange={(e) => handleInputChange(e, "greeting")}
            />
          </div>
        </div>
        <div className="field-stacked" style={{ flex: "0 0 40%" }}></div>
        <div className="field-stacked" style={{ flex: "0 0 30%" }}>
          <label className="field-label">Title:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={school?.title || ""}
              onChange={(e) => handleInputChange(e, "title")}
            />
          </div>
        </div>
        <div className="field-stacked" style={{ flex: "0 0 60%" }}></div>
        <div className="field-stacked" style={{ flex: "0 0 25%" }}>
          <label className="field-label">Address:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={school.address}
              onChange={(e) => handleInputChange(e, "address")}
            />
          </div>
        </div>
        <div className="field-stacked" style={{ flex: "0 0 15%" }}>
          <label className="field-label">Address 2:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={school?.address2 || ""}
              onChange={(e) => handleInputChange(e, "address2")}
            />
          </div>
        </div>
        <div className="field-stacked" style={{ flex: "0 0 15%" }}>
          <label className="field-label">City:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={school.city}
              onChange={(e) => handleInputChange(e, "city")}
            />
          </div>
        </div>
        <div className="field-stacked" style={{ flex: "0 0 15%" }}>
          <label className="field-label">State:</label>
          <select
            className="form-select"
            value={school.state}
            onChange={(e) => handleInputChange(e, "state")}
          >
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state.abbreviation} value={state.abbreviation}>
                {state.name} ({state.abbreviation})
              </option>
            ))}
          </select>
        </div>
        {school?.state === "INT" && (
          <div className="field-stacked" style={{ flex: "0 0 15%" }}>
            <label className="field-label">Country:</label>
            <div className="field-input">
              <input
                className="form-control"
                type="text"
                value={school?.country || ""}
                onChange={(e) => handleInputChange(e, "country")}
              />
            </div>
          </div>
        )}
        <div className="field-stacked" style={{ flex: "0 0 15%" }}>
          <label className="field-label">ZipCode:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={school.zipCode}
              onChange={(e) => handleInputChange(e, "zipCode")}
            />
          </div>
        </div>
        <div className="field-stacked" style={{ flex: "0 0 40%" }}>
          <label className="field-label">Email:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={school.email}
              onChange={(e) => handleInputChange(e, "email")}
            />
          </div>
        </div>
        <div className="field-stacked" style={{ flex: "0 0 20%" }}>
          <label className="field-label">Phone:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={school.phone}
              onChange={(e) => handleInputChange(e, "phone")}
            />
          </div>
        </div>
        <div className="field-stacked" style={{ flex: "0 0 20%" }}>
          <div style={{ display: "flex", gap: "5px" }}>
            <label className="field-label">Send Certified:</label>
            <ToolTip
              tooltipText="Controls if csv box is visible on the reference tracking page once used to build a reference."
              placement="left"
              className="info-icon-spec"
            ></ToolTip>
          </div>
          <div>
            <input
              className="form-check-input"
              type="checkbox"
              checked={school?.sendCertified ? school?.sendCertified : false}
              onChange={(e) => handleInputChange(e, "sendCertified")}
            />
          </div>
        </div>
        {/* <div className="field-stacked" style={{ flex: "0 0 20%" }}>
          <div style={{ display: "flex", gap: "5px" }}>
            <label className="field-label">Verified:</label>
          </div>
          <div>
            <input
              className={`form-check-input`}
              type="checkbox"
              checked={school?.verified}
              onChange={(e) => handleInputChange(e, "verified")}
            />
          </div>
        </div> */}
        <div className="field-stacked" style={{ flex: "0 0 100%" }}>
          <label className="field-label">Comments:</label>
          <div className="field-input">
            <textarea
              className="form-control"
              value={school.comments}
              onChange={(e) => handleInputChange(e, "comments")}
              style={{ height: "100px" }}
              maxLength={4000}
            />
            <div
              style={{
                fontSize: "14px",
                marginTop: "4px",
                textAlign: "right",
              }}
            >
              {school.comments?.length ?? 0}/4000
            </div>
          </div>
        </div>

        <div className="btn-center" style={{ flex: "0 0 100%" }}>
          <button className="oxbtn btn-green" onClick={handleCreateSchool}>
            Create
          </button>
        </div>
      </div>

      {successMessage && (
        <div className="alert-message alert alert-success alert-dismissible fade show">
          {successMessage}
          <button
            type="button"
            className="btn-close"
            onClick={() => setSuccessMessage("")}
            aria-label="Close"
          ></button>
        </div>
      )}

      {errorMessage && (
        <div className="alert-message alert alert-danger">
          {errorMessage}
          <button
            type="button"
            className="btn-close"
            onClick={() => setErrorMessage("")}
          />
        </div>
      )}

      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </div>
  );
};

export default CreateSchool;
